import { inject} from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SharedConstants } from '@constants';
import { EventService } from '@core';

export const backButtonResolver: ResolveFn<boolean> = (route, state) => {
    const eventService = inject(EventService);
    eventService.emitEvent(SharedConstants.UPDATE_BACK_BUTTON_EVENT, { showBack: false });
    return true;
};
